import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ComparisonTableHeaderCell = ({ children, a11yId, className = '' }) => (
  <th
    className={classnames('sm-comparison-table__header-cell', className)}
    data-testid="ComparisonTableHeaderCell"
    id={a11yId}
    scope="col"
    role="columnheader"
  >
    {children}
  </th>
);

ComparisonTableHeaderCell.propTypes = {
  children: PropTypes.node.isRequired,
  a11yId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ComparisonTableHeaderCell.defaultProps = {
  className: '',
};

export default ComparisonTableHeaderCell;
